

<div class="col-12 special_col_padding">
  <div class="border_sections border_sections_customFields">
    <div class="k-block customFieldsBlock">
      <div class="row">
        <div class="col-12">
          @if (_transactionFields?.length > 0) {
            <h2 class="customFieldsTitle">
              Edit Field "{{_transactionFields[0].gridFieldDefinition.gridFieldText.currentText}}"
            </h2>
          }
          <div class="margin">
            <button kendoButton
              class="steps_buttons_class mr-0"
              (click)="onCloseWindow(true)">
              <img class="backimage"
                [src]="'/assets/menu/' + _theme + '/close-schedule-report-icon-green.svg'" />
                <span>Close</span>
              </button>
              <button kendoButton
                class="steps_buttons_class"
                (click)="onSave('Save')">
                <img class="backimage"
                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                  <span>save</span>
                </button>
                <button kendoButton
                  class="steps_buttons_class"
                  (click)="onSave('SaveAndClose')">
                  <img
                    class="backimage"
                    [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'"
                    />
                    <span>save & close</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="row security-level-container">
              <div class="col-12">
                @for (_trans of _transactionFields; track _trans) {
                  <div class="row">
                    <div class="col-3 right-border-section">
                      <span class="fields-style">{{_trans.transaction.transactionName}}</span>
                    </div><!-- [(ngModel)]="getFormTabSecurityLevel(role.name).canView" --><!--[ngModelOptions]="{standalone : true}" (ngModelChange)="onValueChange($event, 'view', role.name, role.id)" -->
                    @if (_trans.isReadOnly == true) {
                      <div class="col-4 right-border-section">
                        <input type="checkbox" class="k-checkbox" kendoCheckBox id="view_{{_trans.id}}" [(ngModel)]="_trans.isSelected"/>
                        <label style="cursor: pointer;" for="view_{{_trans.id}}" class="fields-style">(View Only, not editable)</label>
                      </div>
                    }
                    @if (_trans.isReadOnly == false) {
                      <div class="col-4 right-border-section">
                        <input type="checkbox" class="k-checkbox" kendoCheckBox id="Edit_{{_trans.id}}" [(ngModel)]="_trans.isSelected"/>
                        <label style="cursor: pointer;" for="Edit_{{_trans.id}}" class="fields-style">(Read-Write, editable)</label>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

